import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import site from "@/data/site.json";

export default function Gallery() {
    return (
        <section id="galeria" data-testid="gallery-section" className="py-20 lg:py-28">
            <div className="container-x">
                <SectionHeading
                    align="center"
                    eyebrow="Galeria"
                    title={
                        <>
                            Pets que já <em className="text-coral">sentem o mimo</em>
                        </>
                    }
                    description="Um vislumbre do dia a dia na nossa experiência de cuidado — imagens demonstrativas de banco de imagens licenciado."
                />

                <div className="mt-12 grid auto-rows-[170px] grid-cols-2 gap-3 sm:auto-rows-[200px] md:grid-cols-4 md:gap-4">
                    {site.gallery.map((item, i) => (
                        <motion.figure
                            key={item.src}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.15 }}
                            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: Math.min(i * 0.07, 0.4) }}
                            className={`group relative overflow-hidden rounded-3xl border border-sand ${
                                i === 0 ? "col-span-2 row-span-2" : ""
                            }`}
                            data-testid={`gallery-item-${i + 1}`}
                        >
                            <img
                                src={item.src}
                                alt={item.caption}
                                loading="lazy"
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                            <figcaption className="absolute inset-x-0 bottom-0 flex items-end bg-gradient-to-t from-forest/70 via-forest/10 to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                                <span className="text-sm font-bold text-cream">{item.caption}</span>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
